module.exports = __webpack_public_path__ + "img/glass-outline.f8feb680.png";